import React, { useState, useEffect } from "react";
import { FaTrash, FaArrowUp, FaArrowDown } from "react-icons/fa";

/**
 * RowEditor 컴포넌트 - 선택된 행의 속성을 편집하는 UI를 제공합니다.
 * @param {Object} props - 컴포넌트 props
 * @param {Object} props.selectedRow - 현재 선택된 행 객체
 * @param {Function} props.onUpdateRow - 행 업데이트 핸들러 함수
 * @param {Function} props.onDeleteRow - 행 삭제 핸들러 함수
 * @param {Function} props.onMoveRowUp - 행을 위로 이동하는 핸들러 함수
 * @param {Function} props.onMoveRowDown - 행을 아래로 이동하는 핸들러 함수
 * @param {Function} props.t - 번역 함수
 */
const RowEditor = ({
  selectedRow,
  onUpdateRow,
  onDeleteRow,
  onMoveRowUp,
  onMoveRowDown,
  t = (key) => key, // 기본 번역 함수
}) => {
  // 선택된 행이 없으면 안내 메시지 표시
  if (!selectedRow) {
    return <div className="empty-editor-message">{t("selectRow")}</div>;
  }

  // 행 레이아웃 상태 관리
  const [layout, setLayout] = useState(selectedRow.layout || "full");

  // selectedRow가 변경될 때만 상태 업데이트
  useEffect(() => {
    setLayout(selectedRow.layout || "full");
  }, [selectedRow.id]); // id가 변경될 때만 실행

  // 삭제 버튼 클릭
  const handleDeleteRowClick = () => {
    if (window.confirm(t("confirmDeleteRow"))) {
      onDeleteRow && onDeleteRow(selectedRow.id);
    }
  };

  return (
    <div className="row-editor">
      <div className="property-group">
        <div className="property-group-title">{t("rowSettings")}</div>
        <div className="property-row">
          <button
            className="btn btn-outline"
            onClick={() => onMoveRowUp && onMoveRowUp(selectedRow.id)}
          >
            <FaArrowUp /> {t("moveUp")}
          </button>
          <button
            className="btn btn-outline"
            onClick={() => onMoveRowDown && onMoveRowDown(selectedRow.id)}
          >
            <FaArrowDown /> {t("moveDown")}
          </button>
          <button className="btn btn-danger" onClick={handleDeleteRowClick}>
            <FaTrash /> {t("deleteRow")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RowEditor;
